/* eslint-disable react/no-danger */
import Cookies from 'js-cookie';
import React, { useState } from 'react';
import sanitizeHtml from 'sanitize-html';

import { LinkButton } from '@eika/button';
import { Icon, IconTypes } from '@eika/icon';
import { Modal } from '@eika/modal';
import '@eika/notice-bar-style';

type NoticeBarProps = {
    modalTitle: string;
    noticeMessage: string;
    updatedDate: string;
    id: string;
    appNamespace?: string;
    showMessageButton?: string;
    closeMessageButton?: string;
};

const NoticeBar: React.FC<NoticeBarProps> = ({
    modalTitle,
    noticeMessage,
    updatedDate,
    id,
    appNamespace = 'no-eika-lokalbank',
    showMessageButton = 'Vis melding',
    closeMessageButton = 'Lukk melding',
}) => {
    const [showModal, setShowModal] = useState(false);
    const noticeCookie = Cookies.get(`eika_notice-${id}`);
    const [showNotice, setShowNotice] = useState(!noticeCookie);

    const closeNoticeWithCookie = () => {
        Cookies.set(`eika_notice-${id}`, 'true', { expires: 21 });
        setShowNotice(false);
    };

    const customHeaderContent = (
        <div>
            <span className="sgw-notice-bar__modal-date typography-caption">{updatedDate}</span>
        </div>
    );

    const sanitizedHtmlOptions = {
        allowedAttributes: {
            a: ['class', 'href', 'title', 'aria-*', 'data-*'],
        },
    };

    return showNotice ? (
        <div className="sgw-notice-bar__background">
            <div className="sgw-notice-bar__container">
                <div className="sgw-notice-bar" role="status">
                    <div className="sgw-notice-bar__icon-container">
                        <div className="sgw-notice-bar__icon">
                            <Icon type={IconTypes.UTROPSTEGN_24} aria-hidden="true" />
                        </div>
                        <p className="sgw-notice-bar__date typography-caption">{updatedDate}</p>
                    </div>

                    <div className="sgw-notice-bar__content-container">
                        <div className="sgw-notice-bar__notice-message-wrapper">
                            <div className="sgw-notice-bar__notice-message">
                                <span
                                    className="sgw-notice-bar__notice-message bar-title typography-small bold"
                                    dangerouslySetInnerHTML={{ __html: `${sanitizeHtml(modalTitle)}` }}
                                />
                                <span
                                    className="sgw-notice-bar__notice-message typography-small"
                                    dangerouslySetInnerHTML={{
                                        __html: `${sanitizeHtml(noticeMessage, sanitizedHtmlOptions)}`,
                                    }}
                                />
                            </div>
                        </div>

                        <div className="sgw-notice-bar__button-wrapper">
                            <LinkButton
                                inverted
                                className="sgw-notice-bar__button"
                                onClick={() => setShowModal(!showModal)}
                            >
                                {showMessageButton}
                            </LinkButton>
                        </div>
                    </div>

                    <div className="sgw-notice-bar__close-container">
                        <button
                            type="button"
                            className="sgw-notice-bar__close"
                            aria-label="Lukk varsel"
                            onClick={() => {
                                setShowNotice(false);
                                closeNoticeWithCookie();
                            }}
                        >
                            <Icon type={IconTypes.LUKK_24} />
                        </button>
                    </div>

                    <Modal
                        size="wide"
                        id="sgw-notice-bar__modal"
                        className="sgw-notice-bar__modal"
                        appNamespace={appNamespace}
                        setOpen={setShowModal}
                        title={modalTitle}
                        open={showModal}
                        headerContent={customHeaderContent}
                        growWithContent
                        contentShouldStretch
                        desktopMinHeight="small"
                    >
                        <div
                            className="sgw-notice-bar__main-content"
                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(noticeMessage, sanitizedHtmlOptions) }}
                        />
                        <div className="sgw-notice-bar__modal-action">
                            <LinkButton onClick={() => setShowModal(false)}>{closeMessageButton}</LinkButton>
                        </div>
                    </Modal>
                </div>
            </div>
        </div>
    ) : null;
};

export default NoticeBar;
